import api from "../api";
import {subscribeToChannel, unsubscribeToChannel} from "../services/pusher";

const state = () => ({
  recordId: null,
  communicationLogs: [],
  notes: [],
  primaryContact: {},
  property: {},
  record: {},
  users: {},
  isDuplicate: false,
});

const getters = {
  recordId(state) {
    return state.recordId;
  },
  communicationLogs(state) {
    return state.communicationLogs;
  },
  contact(state) {
    return state.primaryContact;
  },
  contactTypes(state) {
    return state.primaryContact.contactContactTypes;
  },
  record(state) {
    return state.record;
  },
  property(state) {
    return state.property;
  },
  notes(state) {
    return state.notes;
  },
  users(state) {
    return state.users;
  },
  isDuplicate(state) {
    return state.isDuplicate
  },
};

const mutations = {
  setup(state, data) {
    state.communicationLogs = data.communicationLogs;
    state.notes = data.notes;
    state.primaryContact = data.primaryContact;
    state.property = data.property;
    state.record = data.record;
    state.users = data.users;
    state.isDuplicate = data.is_duplicate
  },
  reset(state) {
    state.recordId = null;
    state.communicationLogs = [];
    state.notes = [];
    state.primaryContact = {};
    state.property = {};
    state.record = {};
    state.users = {};
    state.isDuplicate = false
  },
  setActiveInboxLeadItemId(state, recordId) {
    state.recordId = recordId;
  }
};

const actions = {
  setup({commit, state}, recordId) {
    // Make sure you can subscribe to more then one at a time
    if (state.recordId !== null && state.recordId !== recordId) {
      unsubscribeToChannel("activeInboxLeadItem", state.recordId);
    }

    commit('setActiveInboxLeadItemId', recordId);
    subscribeToChannel("activeInboxLeadItem", recordId);

    return api.clientStore.initActiveInboxLeadItem(recordId).then(response => {
      commit('setup', response.data);
    });
  },
  tearDown({commit, state}) {
    if (state.recordId) {
      unsubscribeToChannel("activeInboxLeadItem", state.recordId);
    }

    commit('reset');
  },
};

const ActiveInboxLeadItemStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default ActiveInboxLeadItemStore;
